import { render } from "./SigninUser.vue?vue&type=template&id=10c9055f"
import script from "./SigninUser.vue?vue&type=script&lang=js"
export * from "./SigninUser.vue?vue&type=script&lang=js"

import "./SigninUser.vue?vue&type=style&index=0&id=10c9055f&lang=css"

import exportComponent from "/Volumes/Nok/source/tccc/tccc-station-23-v2/tccc-frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__